import axios from 'axios';
import Loader from '../../_common/scripts/loader.js';
import Phone from '../../_common/scripts/phone.js';
import Shortlist from '../../_common/scripts/shortlist.js';
import ShortlistNew from '../../_common/scripts/shortlist-new.js';
import Lazy from '../../_common/scripts/lazy';

export default class SearchResults {
  init($) {
    const loader = new Loader();
    const phone = new Phone();
    const shortlist = new Shortlist();
    const shortlistNew = new ShortlistNew();

    const getMoreResultsWrapper = () => {
      const wrappers = document.getElementsByClassName('button-more-results-wrapper');

      return wrappers[wrappers.length - 1];
    };

    const addEventsToButton = () => {
      const button = document.getElementsByClassName('view-more-results');
      for (let i = 0; i < button.length; i += 1) {
        button[i].addEventListener('click', showMoreResults, false); //eslint-disable-line
      }
    };

    const renderNewResults = (resultsHTML, filters, wrapper) => {
      wrapper.innerHTML = '';
      const resultsContent = document.getElementById('search-results').innerHTML;
      document.getElementById('search-results').innerHTML = resultsContent + resultsHTML;
      document.getElementById('filters').value = filters;
    };

    const showMoreResults = () => {
      const wrapper = getMoreResultsWrapper();
      wrapper.innerHTML = loader.getLoader();
      const filters = document.getElementById('filters').value;
      const filtersObject = JSON.parse(filters);
      filtersObject.page += 1;

      axios.post('/search', filtersObject)
        .then((response) => {
          renderNewResults(response.data, JSON.stringify(filtersObject), wrapper);
          Lazy.refresh();
          phone.init($);
          shortlist.init($);
          shortlistNew.init($);
          addEventsToButton();
        });
    };
    addEventsToButton();
  }
}



// WEBPACK FOOTER //
// ./_common/scripts/search-results.js